import React from 'react'
import browserDet from 'detect-browser'
import Banner from 'elements/Banner'
import {connect} from 'react-redux'
import i18n from 'lib/i18n'
const _ = i18n('updateBar')

// Force updating after translations loaded
@connect(({dict}) => ({dict}))
export default class UpdateBar extends React.Component {
	render() {
		const browser = browserDet.name
		const version = browserDet.version.split('.')[0]
		const links = [
			{
				label: "chrome",
				minVersion: 45,
				value: "https://www.google.com/chrome/browser/desktop/",
			}, {
				label: "firefox",
				minVersion: 43,
				value: "https://www.mozilla.org/en-US/firefox/new/",
			}, {
				label: "ie",
				minVersion: 11,
				value: "http://windows.microsoft.com/en-us/internet-explorer/download-ie",
			}, {
				label: "safari",
				minVersion: 5,
				value: "https://support.apple.com/downloads/#safari",
			}, {
				label: "opera",
				minVersion: 34,
				value: "http://www.opera.com/download",
			},
		]
		const shouldUpdate = links.find((o) => {
			return o.label === browser && o.minVersion > version
		})
		if (!shouldUpdate) {
			return false
		}
		const destination = shouldUpdate && shouldUpdate.value

		return (
			<Banner
				handleclick={null}
				destination={destination}
				bold={_('bold')}
				beforeLink={_('beforeLink')}
				afterLink={_('afterLink')}
				link={_('link')}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./components/mainComponents/UpdateBar.jsx